import React from "react";
import { motion } from "framer-motion";

const PARTNERS = [
  { name: "Euronext Academy", slug: "euronext-academy", url: "https://www.corporatesolutions.euronext.com/academy" },
  { name: "Risk.net", slug: "risk-net", url: "https://www.risk.net/learning" },
  { name: "UK Finance", slug: "uk-finance", url: "https://www.ukfinance.org.uk/training" },
  { name: "Union of Banks of Armenia", slug: "uba", url: "https://www.uba.am/en/uba/about.html" },
  { name: "Decision Focus", slug: "decision-focus", url: "https://www.decisionfocus.com", ext: "svg" },
  { name: "IIA Norge", slug: "iia-norge", url: "https://www.iia.no" },
  { name: "IIA Sweden", slug: "iia-sweden", url: "https://www.theiia.se/" },
  { name: "IIA Switzerland", slug: "iia-switzerland", url: "https://www.iias.ch/en/" },
  { name: "IIA Greece (Ελλάδα)", slug: "iia-greece", url: "https://www.hiia.gr" },
  { name: "Sijoitusakatemia Finland", slug: "sijoitusakatemia", url: "https://sijoitusakatemia.fi" },
  { name: "Egyptian Banking Institute", slug: "egyptian-banking-institute", url: "https://www.ebi.gov.eg" },
  { name: "Marcus Evans", slug: "marcus-evans", url: "https://www.marcusevans.com/professional-training" },
  { name: "The Møller Institute, Churchill College — Cambridge", slug: "moller-institute", url: "https://www.mollerinstitute.com" },
  { name: "Budapest Institute of Banking", slug: "budapest-institute-of-banking", url: "https://www.bib-edu.hu" },
  { name: "CPE Trainer", slug: "cpe-trainer", url: "https://cpetrainer.com" },
];

export const Clients = () => {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative pt-10 md:pt-14 pb-20 md:pb-28 bg-white border-t border-b border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14 md:mb-20">
          <p className="font-sans-body text-xs tracking-widest-2 uppercase text-[#3E7373] mb-6 inline-flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[#3E7373]" />
            Selected partners
            <span className="inline-block w-8 h-px bg-[#3E7373]" />
          </p>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-[#0D0D0D] font-medium max-w-3xl mx-auto">
            Proudly working with
            <br />
            <span className="italic text-[#3E7373]">these organisations.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
          {PARTNERS.map((p, idx) => (
            <motion.a
              key={p.slug}
              href={p.url}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={`Visit ${p.name}`}
              title={p.name}
              data-testid={`partner-${p.slug}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.55, delay: (idx % 8) * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-white aspect-[3/2] flex items-center justify-center p-6 md:p-8 hover:bg-[#F9F8F6] transition-colors duration-500"
            >
              <img
                src={`/images/partners/${p.slug}.${p.ext || "png"}`}
                alt={p.name}
                loading="lazy"
                decoding="async"
                width="240"
                height="160"
                sizes="(max-width: 768px) 50vw, 20vw"
                className="max-h-full max-w-full object-contain opacity-80 group-hover:opacity-100 transition-opacity duration-500"
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
